class FluidTherapyCalculator extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    const root = this;

    'use strict';

    const $ = (id) => root.querySelector(`#${id}`);

    const num = (id) => {
      const value = $(id).value;

      return value === '' ? null : parseFloat(value);
    };

    let species = root.dataset.defaultSpecies === 'cat' ? 'cat' : 'dog';

    const speciesButtons = root.querySelectorAll('#speciesSeg button');

    const SP_DEFAULTS = {
      dog: {
        naLow: 140,
        naHigh: 155,
        clLow: 105,
        clHigh: 120,
        gluHigh: 6.5
      },
      cat: {
        naLow: 150,
        naHigh: 162,
        clLow: 110,
        clHigh: 125,
        gluHigh: 8.5
      }
    };

    function updateSpeciesButtons() {
      speciesButtons.forEach((button) => {
        const isActive = button.dataset.sp === species;

        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });
    }

    function applySpeciesDefaults() {
      const defaults = SP_DEFAULTS[species];

      for (const key in defaults) {
        $(key).value = defaults[key];
      }
    }

    speciesButtons.forEach((button) => {
      button.addEventListener('click', () => {
        species = button.dataset.sp;

        updateSpeciesButtons();
        applySpeciesDefaults();
        render();
      });
    });

    updateSpeciesButtons();
    applySpeciesDefaults();

    const FIXED_DEFAULTS = {
      p1pct: 50,
      p1h: 6,
      p2h: 18,
      htsNa: 1155,
      kLow: 3.6,
      kHigh: 5.5,
      icaLow: 1.1,
      icaHigh: 1.4,
      tcaLow: 2.0,
      tcaHigh: 3.0,
      gluLow: 3.3,
      phosLow: 0.8,
      phosHigh: 2.0
    };

    function resetAll() {
      root
        .querySelectorAll('#inputs input[type=number]')
        .forEach((element) => {
          element.value = '';
        });

      root
        .querySelectorAll('#inputs input[type=checkbox]')
        .forEach((element) => {
          element.checked = false;
        });

      $('dehy').value = '0';
      $('bagml').value = '1000';

      for (const key in FIXED_DEFAULTS) {
        $(key).value = FIXED_DEFAULTS[key];
      }

      species = root.dataset.defaultSpecies === 'cat' ? 'cat' : 'dog';

      updateSpeciesButtons();
      applySpeciesDefaults();
      render();
    }

    $('resetBtn').addEventListener('click', resetAll);
    $('printBtn').addEventListener('click', () => window.print());

    function planText() {
      const wt = num('wt');

      if (!wt || wt <= 0) return '';

      const head =
        'ASK A VET (TM) — Fluid Therapy Plan\n' +
        (species === 'dog' ? 'Dog' : 'Cat') +
        ', ' +
        wt +
        ' kg — ' +
        new Date().toLocaleString() +
        '\n' +
        '='.repeat(44) +
        '\n\n';

      return (
        head +
        $('out').innerText.replace(/\n{3,}/g, '\n\n') +
        '\n\n' +
        '-'.repeat(44) +
        '\nDecision support for veterinary professionals only. Verify all doses against the patient and your hospital protocol. askavet.com'
      );
    }

    function actionStatus(message) {
      const status = $('actionStatus');

      status.textContent = message;

      setTimeout(() => {
        if (status.textContent === message) {
          status.textContent = '';
        }
      }, 5000);
    }

    $('copyBtn').addEventListener('click', async () => {
      const text = planText();

      if (!text) {
        actionStatus(
          'Enter a body weight first — there is no plan to copy yet.'
        );

        return;
      }

      try {
        await navigator.clipboard.writeText(text);

        actionStatus('Plan copied to clipboard.');
      } catch (error) {
        const textarea = document.createElement('textarea');

        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);

        textarea.select();

        try {
          document.execCommand('copy');

          actionStatus('Plan copied to clipboard.');
        } catch (fallbackError) {
          actionStatus(
            'Copy is blocked in this browser — use Print / Save PDF instead.'
          );
        }

        textarea.remove();
      }
    });

    $('emailBtn').addEventListener('click', () => {
      let text = planText();

      if (!text) {
        actionStatus(
          'Enter a body weight first — there is no plan to email yet.'
        );

        return;
      }

      if (text.length > 1600) {
        text =
          text.slice(0, 1600) +
          '\n...\n(Plan truncated by email length limits — use Print / Save PDF for the full plan.)';
      }

      const subject =
        'Fluid therapy plan — ' +
        (species === 'dog' ? 'dog' : 'cat') +
        ', ' +
        num('wt') +
        ' kg';

      window.location.href =
        'mailto:?subject=' +
        encodeURIComponent(subject) +
        '&body=' +
        encodeURIComponent(text);

      actionStatus('Opening your email app with the plan…');
    });

    const fmt = (value, decimals = 0) =>
      value == null || isNaN(value)
        ? '—'
        : Number(value)
            .toFixed(decimals)
            .replace(
              /\.0+$/,
              (match) =>
                decimals > 0 && Number(value) % 1 === 0 ? '' : match
            );

    const KCL_TABLE = [
      {
        max: 2.0,
        label: '<2.0',
        add: 80,
        rate: 6
      },
      {
        max: 2.5,
        label: '2.1–2.5',
        add: 60,
        rate: 8
      },
      {
        max: 3.0,
        label: '2.6–3.0',
        add: 40,
        rate: 12
      },
      {
        max: 3.5,
        label: '3.1–3.5',
        add: 30,
        rate: 18
      },
      {
        max: 5.0,
        label: '3.6–5.0',
        add: 20,
        rate: 25
      }
    ];

    function card(severity, title, pills, body) {
      return `
        <div class="rcard ${severity}">
          <h3>${title}</h3>
          ${pills ? `<div class="flagrow">${pills}</div>` : ''}
          ${body}
        </div>
      `;
    }

    const pill = (severity, text) =>
      `<span class="pill ${severity}">${text}</span>`;

    const dose = (text) =>
      `<span class="dose">${text}</span>`;

    const tbl = (inner) =>
      `<div class="tblwrap"><table>${inner}</table></div>`;

    function render() {
      const wt = num('wt');
      const out = $('out');

      if (!wt || wt <= 0) {
        out.innerHTML =
          '<div class="empty">Enter a body weight (kg) in step 1 to generate a fluid plan. Blood results are optional — anything left blank is skipped.</div>';

        return;
      }

      const v = {
        na: num('na'),
        k: num('k'),
        cl: num('cl'),
        ica: num('ica'),
        tca: num('tca'),
        phos: num('phos'),
        glu: num('glu'),
        lact: num('lact'),
        hco3: num('hco3'),
        tp: num('tp'),
        alb: num('alb'),
        pcv: num('pcv')
      };

      const r = {
        naLow: num('naLow'),
        naHigh: num('naHigh'),
        kLow: num('kLow'),
        kHigh: num('kHigh'),
        clLow: num('clLow'),
        clHigh: num('clHigh'),
        icaLow: num('icaLow'),
        icaHigh: num('icaHigh'),
        tcaLow: num('tcaLow'),
        tcaHigh: num('tcaHigh'),
        gluLow: num('gluLow'),
        gluHigh: num('gluHigh'),
        phosLow: num('phosLow'),
        phosHigh: num('phosHigh')
      };

      const dehy = parseFloat($('dehy').value);
      const shock = $('shock').checked;
      const neuro = $('neuro').checked;
      const sepsis = $('sepsis').checked;
      const aki = $('aki').checked;
      const coag = $('coag').checked;
      const paed = $('paed').checked;
      const losses = Math.max(0, num('losses') || 0);
      const htsNa = num('htsNa') || 1155;
      const bag = parseFloat($('bagml').value) || 1000;

      const dexAdd = (pct) => bag * pct / 50;

      const F = {};

      if (v.na != null) {
        if (v.na < r.naLow) {
          F.hypoNa = {
            sev: v.na < 120 || neuro ? 'crit' : 'warn',
            deg: v.na < 120 ? 'severe' : 'mild–moderate'
          };
        } else if (v.na > r.naHigh) {
          F.hyperNa = {
            sev: v.na > 170 || neuro ? 'crit' : 'warn',
            deg:
              v.na > 170
                ? 'severe'
                : v.na > 160
                  ? 'moderate'
                  : 'mild'
          };
        }
      }

      if (v.k != null) {
        if (v.k < r.kLow) {
          F.hypoK = {
            sev: v.k < 2.5 ? 'crit' : 'warn',
            deg:
              v.k < 2.5
                ? 'severe'
                : v.k < 3
                  ? 'moderate'
                  : 'mild'
          };
        } else if (v.k > r.kHigh) {
          F.hyperK = {
            sev: v.k > 6.5 ? 'crit' : 'warn',
            deg:
              v.k > 9
                ? 'severe'
                : v.k > 6.5
                  ? 'moderate–severe'
                  : 'mild'
          };
        }
      }

      if (
        v.glu != null &&
        r.gluLow != null &&
        v.glu < r.gluLow
      ) {
        F.hypoGlu = {
          sev: 'crit'
        };
      }

      if (
        v.glu != null &&
        r.gluHigh != null &&
        v.glu > r.gluHigh
      ) {
        F.hyperGlu = {
          sev: 'warn'
        };
      }

      const ca =
        v.ica != null
          ? {
              val: v.ica,
              lo: r.icaLow,
              hi: r.icaHigh,
              ion: true
            }
          : v.tca != null
            ? {
                val: v.tca,
                lo: r.tcaLow,
                hi: r.tcaHigh,
                ion: false
              }
            : null;

      if (ca) {
        if (ca.val < ca.lo) {
          F.hypoCa = {
            sev: neuro ? 'crit' : 'warn',
            ion: ca.ion
          };
        } else if (ca.val > ca.hi) {
          F.hyperCa = {
            sev: 'warn',
            ion: ca.ion
          };
        }
      }

      if (v.phos != null) {
        if (v.phos < 0.65) {
          F.hypoPhos = {
            sev: v.phos < 0.3 ? 'warn' : 'info',
            initiate: v.phos < 0.3
          };
        } else if (
          r.phosHigh != null &&
          v.phos > r.phosHigh
        ) {
          F.hyperPhos = {
            sev: 'warn'
          };
        }
      }

      if (v.lact != null && v.lact > 2) {
        F.hyperLact = {
          sev: v.lact > 4 ? 'crit' : 'warn'
        };
      }

      if (v.hco3 != null && v.hco3 < 18) {
        F.acidosis = {
          sev: v.hco3 < 10 ? 'crit' : 'warn',
          severe: v.hco3 < 10
        };
      }

      if (
        v.hco3 != null &&
        v.hco3 > 26 &&
        v.cl != null &&
        r.clLow != null &&
        v.cl < r.clLow
      ) {
        F.alkalosis = {
          sev: 'warn'
        };
      }

      if (v.tp != null && v.tp < 45) {
        F.lowTP = {
          sev: 'warn'
        };
      }

      if (
        v.cl != null &&
        r.clHigh != null &&
        v.cl > r.clHigh &&
        !F.hyperNa
      ) {
        F.hyperCl = {
          sev: 'info'
        };
      }

      if (
        v.cl != null &&
        r.clLow != null &&
        v.cl < r.clLow &&
        !F.hypoNa &&
        !F.alkalosis
      ) {
        F.hypoCl = {
          sev: 'info'
        };
      }

      const cards = [];

      {
        const flags = [];

        const names = {
          hypoNa: 'Hyponatraemia',
          hyperNa: 'Hypernatraemia',
          hypoK: 'Hypokalaemia',
          hyperK: 'Hyperkalaemia',
          hypoGlu: 'Hypoglycaemia',
          hyperGlu: 'Hyperglycaemia',
          hypoCa: 'Hypocalcaemia',
          hyperCa: 'Hypercalcaemia',
          hypoPhos: 'Hypophosphataemia',
          hyperPhos: 'Hyperphosphataemia',
          hyperLact: 'Hyperlactataemia',
          acidosis: 'Metabolic acidosis',
          alkalosis: 'Hypochloraemic alkalosis',
          lowTP: 'Low oncotic pressure (TP<45)',
          hyperCl: 'Hyperchloraemia',
          hypoCl: 'Hypochloraemia'
        };

        for (const key in F) {
          const flag = F[key];

          flags.push(
            pill(
              flag.sev,
              names[key] +
                (flag.deg ? ` (${flag.deg})` : '')
            )
          );
        }

        if (shock) {
          flags.unshift(
            pill('crit', 'Perfusion deficit')
          );
        }

        if (dehy > 0) {
          flags.push(
            pill(
              dehy >= 12 ? 'crit' : 'warn',
              `${dehy}% dehydrated`
            )
          );
        }

        if (!flags.length) {
          flags.push(
            pill(
              'ok',
              'No abnormalities flagged on entered values'
            )
          );
        }

        const order = [
          'crit',
          'warn',
          'info',
          'ok'
        ];

        const severity =
          shock ||
          Object.values(F).some(
            (flag) => flag.sev === 'crit'
          )
            ? 'crit'
            : Object.keys(F).length || dehy > 0
              ? 'warn'
              : 'ok';

        cards.push(
          card(
            severity,
            `<span aria-hidden="true">${species === 'dog' ? '🐶' : '🐱'}</span> Problem list — ${species === 'dog' ? 'Dog' : 'Cat'}, ${fmt(wt, 1)} kg`,
            flags
              .sort(
                (a, b) =>
                  order.findIndex((item) =>
                    a.includes(`pill ${item}`)
                  ) -
                  order.findIndex((item) =>
                    b.includes(`pill ${item}`)
                  )
              )
              .join(''),
            '<p class="note">Order of therapy: 1) correct perfusion → 2) rehydrate → 3) maintenance → 4) ongoing losses. Electrolyte corrections run alongside.</p>'
          )
        );
      }

      if (shock || F.hyperLact) {
        const halfShock =
          species === 'dog' ? 40 : 30;

        const bloodVol =
          species === 'dog' ? 90 : 60;

        const htsOK =
          !(dehy >= 5) &&
          !F.hyperNa &&
          !F.hypoNa;

        const body = `
          <ul>
            <li>
              Isotonic crystalloid bolus
              ${dose(`10 ml/kg = ${fmt(10 * wt)} ml IV`)},
              repeat while reassessing end-points
              (mentation, HR, MM, CRT, MAP 70–80, lactate &lt;2,
              UOP &gt;1–2 ml/kg/h).
            </li>

            <li>
              If
              ${dose(`${halfShock} ml/kg = ${fmt(halfShock * wt)} ml`)}
              (50% of shock dose) given with no improvement →
              add a colloid or hypertonic saline bolus if not contraindicated.
            </li>

            <li>
              Hypertonic saline:
              ${
                htsOK
                  ? dose(
                      `2–5 ml/kg = ${fmt(2 * wt)}–${fmt(5 * wt)} ml over 1 ml/kg/min`
                    ) +
                    ' — give concurrent isotonic crystalloid but drop boluses to 5 ml/kg.'
                  : `<strong>contraindicated here</strong> (${[
                      dehy >= 5 ? 'dehydration' : null,
                      F.hyperNa
                        ? 'hypernatraemia'
                        : null,
                      F.hypoNa
                        ? 'hyponatraemia'
                        : null
                    ]
                      .filter(Boolean)
                      .join(', ')}).`
              }
            </li>

            <li>
              Colloid:
              ${dose(`5–10 ml/kg = ${fmt(5 * wt)}–${fmt(10 * wt)} ml`)}
              with continued 5 ml/kg crystalloid boluses
              ${
                sepsis || aki || coag
                  ? ` — <strong>caution/avoid:</strong> ${[
                      sepsis ? 'sepsis' : null,
                      aki ? 'AKI' : null,
                      coag
                        ? 'coagulopathy/thrombocytopaenia'
                        : null
                    ]
                      .filter(Boolean)
                      .join(', ')}.`
                  : '. Avoid in sepsis, AKI, coagulopathy; no CRIs; monitor aPTT with large volumes.'
              }
            </li>

            <li>
              If &gt; one blood volume
              (${dose(`${bloodVol} ml/kg = ${fmt(bloodVol * wt)} ml`)})
              given without response → reassess for cardiogenic,
              obstructive or distributive shock and ongoing losses
              (internal haemorrhage).
            </li>
          </ul>
        `;

        cards.push(
          card(
            'crit',
            '<span aria-hidden="true">💉</span> Step 1 — Correct perfusion first',
            pill(
              'crit',
              'Resuscitate before rehydration'
            ),
            body
          )
        );
      }

      let fluid;
      const why = [];
      const avoid = [];

      if (F.hyperCa || F.hyperPhos) {
        fluid = '0.9% NaCl';

        why.push(
          `${
            F.hyperCa
              ? 'hypercalcaemia'
              : 'hyperphosphataemia'
          } — saline diuresis enhances urinary excretion (calcium-free fluid)`
        );

        avoid.push(
          "Hartmann's (contains calcium)"
        );
      } else if (F.hypoNa) {
        fluid = '0.9% NaCl (Na 154)';

        why.push(
          'hyponatraemia — choose fluid Na within 5–10 mmol/L of patient; mix with 5% dextrose if patient Na is much lower (see correction card)'
        );

        avoid.push(
          'rapid Na rise >0.5 mmol/L/h (myelinolysis risk)',
          'hypertonic saline'
        );
      } else if (F.hyperNa) {
        fluid =
          "Replacement crystalloid (Hartmann's / Plasmalyte 148) supplemented with Na";

        why.push(
          'hypernatraemia with volume/hydration deficit — resuscitate with fluid Na within 5–10 mmol/L of serum, then replace free water slowly (see correction card)'
        );

        avoid.push(
          'rapid Na fall >0.5 mmol/L/h (cerebral oedema)',
          'unsupplemented low-Na fluids during resuscitation'
        );
      } else if (
        F.hyperK &&
        v.k > 6.5
      ) {
        fluid =
          '0.9% NaCl (potassium-free) — any balanced isotonic acceptable';

        why.push(
          'moderate–severe hyperkalaemia — dilution and improved perfusion lower K⁺; alkalinising fluids also shift K⁺ intracellularly'
        );
      } else if (
        F.alkalosis ||
        F.hypoCl
      ) {
        fluid = '0.9% NaCl';

        why.push(
          'hypochloraemic alkalosis — high-chloride, acidifying fluid replaces the Cl⁻ deficit'
        );

        avoid.push(
          "alkalinising fluids (Hartmann's/Plasmalyte) as first choice"
        );
      } else if (F.acidosis) {
        fluid =
          "Hartmann's or Plasmalyte 148";

        why.push(
          'metabolic acidosis — lactate/acetate buffers metabolise to bicarbonate (alkalinising)'
        );

        avoid.push(
          '0.9% NaCl as first line (acidifying, hyperchloraemic)'
        );
      } else {
        fluid =
          "Hartmann's or Plasmalyte 148";

        why.push(
          'balanced isotonic replacement crystalloid resembling ECF — default for perfusion, rehydration and ongoing losses'
        );
      }

      if (
        F.hyperK &&
        !why.some((item) =>
          item.includes('kalaemia')
        )
      ) {
        why.push(
          'mild hyperkalaemia — correct volume and dehydration deficits; avoid added K⁺'
        );
      }

      if (F.hyperGlu) {
        why.push(
          'hyperglycaemia — use glucose-free fluids; recheck glucose q2–4h (stress vs diabetes: history, glucose curve, fructosamine)'
        );
      }

      if (paed) {
        why.push(
          `anorexic paediatric — consider adding 2.5% dextrose to maintenance: add ${fmt(dexAdd(2.5))} ml of 50% dextrose to your ${fmt(bag)} ml bag (remove equal volume first; peripheral-vein safe at ≤5%)`
        );
      }

      let fluidBody = `
        <p style="font-size:17px;margin:4px 0 8px">
          <strong>${fluid}</strong>
        </p>

        <ul>
          ${why
            .map(
              (item) => `<li>${item}</li>`
            )
            .join('')}
        </ul>
      `;

      if (avoid.length) {
        fluidBody += `
          <p class="note">
            <strong>Avoid:</strong>
            ${avoid.join('; ')}.
          </p>
        `;
      }

      cards.push(
        card(
          'accent',
          'Recommended base fluid',
          pill(
            'accent',
            'Step 2–4 vehicle'
          ),
          fluidBody
        )
      );

      let plannedMaxRate;

      {
        const p1pct = Math.min(
          50,
          Math.max(
            25,
            num('p1pct') || 50
          )
        );

        const p1h = Math.min(
          6,
          Math.max(
            4,
            num('p1h') || 6
          )
        );

        const p2h = Math.min(
          24,
          Math.max(
            18,
            num('p2h') || 18
          )
        );

        const defML =
          dehy * wt * 10;

        const maint =
          (species === 'dog'
            ? 132
            : 80) *
          Math.pow(wt, 0.75);

        const maintHr = maint / 24;
        const lossHr = losses / 24;

        const p1rate =
          (defML * p1pct) /
            100 /
            p1h +
          maintHr +
          lossHr;

        const p2rate =
          (defML *
            (100 - p1pct)) /
            100 /
            p2h +
          maintHr +
          lossHr;

        const ongoing =
          maintHr + lossHr;

        let body = `
          <div class="bigrow">
            <div class="bigbox">
              <span class="biglabel">
                Phase 1 — first ${p1h} h
              </span>

              <span class="bignum">
                ${fmt(p1rate)}
                <small>ml/h</small>
              </span>
            </div>

            <div class="bigbox">
              <span class="biglabel">
                Phase 2 — next ${p2h} h
              </span>

              <span class="bignum">
                ${fmt(p2rate)}
                <small>ml/h</small>
              </span>
            </div>

            <div class="bigbox">
              <span class="biglabel">
                Then ongoing
              </span>

              <span class="bignum">
                ${fmt(ongoing)}
                <small>ml/h</small>
              </span>
            </div>
          </div>

          <div class="formula">
            Rate = fluid deficit + maintenance + ongoing losses
          </div>
        `;

        body += tbl(`
          <tr>
            <th>Component</th>
            <th>Calculation</th>
            <th>Value</th>
          </tr>

          <tr>
            <td>Fluid deficit</td>
            <td>${dehy}% × ${fmt(wt, 1)} kg × 10</td>
            <td>${fmt(defML)} ml</td>
          </tr>

          <tr>
            <td>Maintenance</td>
            <td>
              ${
                species === 'dog'
                  ? '132'
                  : '80'
              }
              × ${fmt(wt, 1)}<sup>0.75</sup>
            </td>
            <td>
              ${fmt(maint)} ml/day
              (${fmt(maintHr, 1)} ml/h)
            </td>
          </tr>

          <tr>
            <td>Ongoing losses</td>
            <td>estimated</td>
            <td>
              ${fmt(losses)} ml/day
              (${fmt(lossHr, 1)} ml/h)
            </td>
          </tr>

          <tr class="hl">
            <td>
              Phase 1 — ${p1pct}% of deficit over ${p1h} h
            </td>
            <td>
              + maintenance + losses
            </td>
            <td>${fmt(p1rate)} ml/h</td>
          </tr>

          <tr class="hl">
            <td>
              Phase 2 — remaining ${100 - p1pct}% over ${p2h} h
            </td>
            <td>
              + maintenance + losses
            </td>
            <td>${fmt(p2rate)} ml/h</td>
          </tr>
        `);

        if (dehy === 0) {
          body += `
            <p class="note">
              No dehydration entered — rate is maintenance ± losses only.
            </p>
          `;
        }

        body += `
          <p class="note">
            <span aria-hidden="true">⚠️</span>
            Watch for volume overload: ↑RR, crackles,
            soft moist cough, serous nasal/ocular discharge,
            subcutaneous oedema (paws/ventrum).
            Monitor PCV/TP for haemodilution — consider colloids
            if TP &lt;45 g/L, whole blood if PCV falling.
          </p>
        `;

        cards.push(`
          <div class="rcard result-dark">
            <h3>
              Fluid rate plan (after perfusion is corrected)
            </h3>

            ${body}
          </div>
        `);

        plannedMaxRate = Math.max(
          p1rate,
          p2rate,
          ongoing
        );
      }

      if (F.hypoK) {
        const row =
          KCL_TABLE.find(
            (item) => v.k <= item.max
          ) ||
          KCL_TABLE[
            KCL_TABLE.length - 1
          ];

        const maxHr =
          row.rate * wt;

        const over =
          plannedMaxRate > maxHr;

        const safeConc = Math.floor(
          (0.5 * wt * 1000) /
            plannedMaxRate
        );

        let rows = `
          <tr>
            <th>Serum K⁺</th>
            <th>Add KCl to 1 L bag</th>
            <th>
              Max fluid rate
              (0.5 mEq/kg/h)
            </th>
            <th>This patient</th>
          </tr>
        `;

        KCL_TABLE.forEach(
          (item) => {
            rows += `
              <tr${
                item === row
                  ? ' class="hl"'
                  : ''
              }>
                <td>${item.label}</td>
                <td>${item.add} mmol/L</td>
                <td>${item.rate} ml/kg/h</td>
                <td>${fmt(item.rate * wt)} ml/h</td>
              </tr>
            `;
          }
        );

        const body =
          tbl(rows) +
          `
            <ul>
              <li>
                Add
                ${dose(`${row.add} mmol KCl per litre`)}
                =
                ${dose(`${fmt(row.add * bag / 1000)} mmol for your ${fmt(bag)} ml bag`)}
                →
                max infusion
                ${dose(`${fmt(maxHr)} ml/h`)}
                for this patient.
              </li>

              ${
                over
                  ? `
                    <li>
                      <strong>
                        Planned rate ${fmt(plannedMaxRate)} ml/h
                        exceeds the K⁺ ceiling.
                      </strong>

                      Either run a second K-free line for the extra volume,
                      or cap this bag at
                      ${dose(`${safeConc} mmol/L`)}
                      so 0.5 mEq/kg/h is not exceeded at
                      ${fmt(plannedMaxRate)} ml/h.
                    </li>
                  `
                  : ''
              }

              <li>
                Aim &lt;0.5 mEq/kg/h IV;
                up to 1 mEq/kg/h only for severe DKA on insulin
                with continuous ECG.
                High fluid rates worsen hypokalaemia —
                recheck K⁺ frequently and adjust.
              </li>

              ${
                v.k >= 3
                  ? `
                    <li>
                      Mild (3–3.5):
                      restore feeding ± oral potassium gluconate
                      1–3 mEq/kg/day divided BID–TID
                      (K gluconate 1 g = 4.3 mEq;
                      KCl 1 g = 13.4 mEq).
                    </li>
                  `
                  : ''
              }

              ${
                v.k < 3 && v.k >= 2.5
                  ? `
                    <li>
                      Moderate (&lt;3):
                      oral supplementation combined with IV fluid therapy.
                    </li>
                  `
                  : ''
              }

              ${
                v.k < 2.5
                  ? `
                    <li>
                      Severe (&lt;2.5):
                      IV therapy; risk of neuromuscular weakness —
                      ECG monitoring.
                    </li>
                  `
                  : ''
              }

              <li>
                DKA patients:
                consider giving part as potassium phosphate
                (hypophosphataemia is common).
              </li>
            </ul>
          `;

        cards.push(
          card(
            F.hypoK.sev,
            `Hypokalaemia correction — K⁺ ${fmt(v.k, 1)}`,
            pill(
              F.hypoK.sev,
              F.hypoK.deg
            ),
            body
          )
        );
      } else if (v.k == null) {
        cards.push(
          card(
            'info',
            'Potassium not entered',
            null,
            `
              <p class="note">
                For maintenance fluid therapy the protocol adds
                10–20 mmol KCl per litre
                (maintenance fluids should be lower Na⁺, higher K⁺).
                Measure K⁺ before supplementing.
              </p>
            `
          )
        );
      }

      if (F.hyperK) {
        const severe =
          v.k > 6.5;

        let body = `
          <ul>
            <li>
              Correct volume and dehydration deficits
              with IV crystalloids —
              dilution and renal perfusion lower K⁺.
              No added potassium.
            </li>
        `;

        if (severe) {
          body += `
            <li>
              <strong>Cardioprotection:</strong>
              calcium gluconate 10%
              ${dose(`0.5–1.5 ml/kg = ${fmt(0.5 * wt, 1)}–${fmt(1.5 * wt, 1)} ml slow IV over 10 min`)}
              with ECG —
              protects within minutes for ~20 min;
              does not lower K⁺, so follow with:
            </li>

            <li>
              <strong>Insulin + dextrose:</strong>
              regular insulin
              ${dose(`0.25–0.5 U/kg = ${fmt(0.25 * wt, 2)}–${fmt(0.5 * wt, 2)} U IV`)}
              ALWAYS with 2 g dextrose per unit:
              ${dose(`${fmt(4 * 0.25 * wt)}–${fmt(4 * 0.5 * wt)} ml of 50% dextrose`)}
              (or
              ${fmt(40 * 0.25 * wt)}–${fmt(40 * 0.5 * wt)}
              ml of 5%),
              then 2.5% dextrose CRI at maintenance for 6–8 h —
              add
              ${dose(`${fmt(dexAdd(2.5))} ml of 50% dextrose`)}
              to your
              ${fmt(bag)}
              ml bag
              (remove equal volume first; ≤5% is peripheral-vein safe).
              Monitor glucose and K⁺.
            </li>

            <li>
              <strong>Bicarbonate</strong>
              (if severe hyperkalaemia or HCO₃⁻ &lt;10):
              ${dose(`1 mmol/kg = ${fmt(wt)} ml of 8.4% over 30 min`)}
              —
              acts in ~15 min;
              may blunt calcium's cardioprotection.
            </li>
          `;
        }

        body += `
            <li>
              ECG any patient with K⁺ &gt;6.0
              (peaked T, prolonged PR, flat P, wide QRS,
              bradycardia/atrial standstill).
              Severity of signs correlates poorly with the number.
            </li>

            <li>
              Rule-outs:
              obstructive/ruptured uropathy,
              anuric renal failure,
              hypoadrenocorticism
              (check Na⁺; rule out whipworm),
              acidosis,
              crush injury,
              drugs
              (ACEi, TMS, spironolactone),
              haemolysed sample artefact.
            </li>
          </ul>
        `;

        cards.push(
          card(
            F.hyperK.sev,
            `Hyperkalaemia — K⁺ ${fmt(v.k, 1)}`,
            pill(
              F.hyperK.sev,
              F.hyperK.deg
            ) +
              (severe
                ? pill(
                    'crit',
                    'ECG now'
                  )
                : ''),
            body
          )
        );
      }

      if (!F.hyperK) {
        const recConc = F.hypoK
          ? (
              KCL_TABLE.find(
                (item) =>
                  v.k <= item.max
              ) ||
              KCL_TABLE[
                KCL_TABLE.length - 1
              ]
            ).add
          : null;

        const concentrations = [
          10,
          20,
          30,
          40,
          60,
          80
        ];

        let rows = `
          <tr>
            <th>K⁺ in bag</th>
            <th>
              Add KCl to ${fmt(bag)} ml bag
            </th>
            <th>
              Min rate
              (delivers 1 mEq/kg/day)
            </th>
            <th>
              Max rate
              (0.5 mEq/kg/h ceiling)
            </th>
          </tr>
        `;

        concentrations.forEach(
          (concentration) => {
            const minRate =
              (wt * 1000) /
              (24 * concentration);

            const maxRate =
              (0.5 * wt * 1000) /
              concentration;

            rows += `
              <tr${
                concentration === recConc
                  ? ' class="hl"'
                  : ''
              }>
                <td>
                  ${concentration} mmol/L
                </td>

                <td>
                  ${fmt(concentration * bag / 1000)}
                  mmol
                </td>

                <td>
                  ${fmt(minRate)} ml/h
                  (${fmt(minRate / wt, 1)} ml/kg/h)
                </td>

                <td>
                  ${fmt(maxRate)} ml/h
                  (${fmt(maxRate / wt, 1)} ml/kg/h)
                </td>
              </tr>
            `;
          }
        );

        const concLow =
          (wt * 1000) /
          (24 * plannedMaxRate);

        const concHigh =
          (0.5 * wt * 1000) /
          plannedMaxRate;

        const body =
          tbl(rows) +
          `
            <ul>
              <li>
                <strong>Maximum</strong>
                = the potassium safety ceiling
                of 0.5 mEq/kg/h —
                never exceed it.
                Up to 1 mEq/kg/h
                (double every maximum above)
                only for severe DKA on insulin
                with continuous ECG monitoring.
              </li>

              <li>
                <strong>Minimum</strong>
                = the slowest rate that still delivers
                the daily potassium requirement
                of ~1 mEq/kg/day.
                Below this the bag is not meaningfully supplementing —
                use a stronger concentration rather than
                a trickle of a weak one.
              </li>

              <li>
                At your planned rate of
                ${dose(`${fmt(plannedMaxRate)} ml/h`)},
                a bag between
                ${dose(`${fmt(Math.ceil(concLow))} and ${fmt(Math.min(Math.floor(concHigh), 80))} mmol/L`)}
                sits inside both limits
                ${
                  concHigh < 10
                    ? ' — planned rate is too high for even 10 mmol/L; run potassium in a second, slower line'
                    : ''
                }.
              </li>

              <li>
                Routine maintenance fluids:
                add 10–20 mmol KCl per litre.
                Always mix the bag thoroughly and label it.
              </li>

              ${
                recConc
                  ? `
                    <li>
                      Highlighted row =
                      the concentration recommended
                      for this patient's K⁺ of
                      ${fmt(v.k, 1)} mmol/L.
                    </li>
                  `
                  : ''
              }
            </ul>
          `;

        cards.push(
          card(
            'info',
            'Potassium in the bag — minimum & maximum rates',
            pill(
              'info',
              'Safe rate ranges'
            ),
            body
          )
        );
      }

      const targetNaAuto = F.hyperNa
        ? r.naHigh
        : F.hypoNa
          ? r.naLow
          : null;

      const targetNa =
        num('targetNa') ||
        targetNaAuto;

      if (F.hyperNa) {
        const baseNa =
          num('baseNa') || 131;

        const fluidTarget = Math.max(
          v.na - 10,
          Math.min(
            v.na - 5,
            v.na - 7
          )
        );

        const addML =
          ((baseNa - fluidTarget) *
            1000) /
          (fluidTarget - htsNa);

        const freeWaterDeficit =
          (v.na / targetNa - 1) *
          0.6 *
          wt;

        const hours =
          (v.na - targetNa) / 0.5;

        const d5wHr =
          (freeWaterDeficit * 1000) /
          hours;

        let body = `
          <p>
            <strong>
              Never drop Na⁺ faster than 0.5 mmol/L/h
            </strong>
            (cerebral oedema).
            Recheck electrolytes q4h.
            Target here:
            ${dose(`${fmt(targetNa)} mmol/L`)}
            →
            minimum correction time
            ${dose(`${fmt(hours)} h`)}
            ${
              hours > 24
                ? ` (${fmt(hours / 24, 1)} days)`
                : ''
            }.
          </p>
        `;

        if (dehy > 0 || shock) {
          body += `
            <p>
              <strong>
                Hypovolaemic path (dehydrated/shocked):
              </strong>
              resuscitate with crystalloid supplemented
              to within 5–10 mmol/L of serum
              (fluid Na ≈ ${fmt(fluidTarget)}):
            </p>

            <div class="formula">
              Add =
              (fluid Na − desired Na)
              × 1000
              ÷
              (desired Na − HTS Na)
              =
              (${fmt(baseNa)} − ${fmt(fluidTarget)})
              × 1000
              ÷
              (${fmt(fluidTarget)} − ${fmt(htsNa)})
            </div>

            <ul>
              <li>
                Add
                ${dose(`${fmt(Math.abs(addML) * bag / 1000, 1)} ml of hypertonic saline`)}
                to each
                ${fmt(bag)}
                ml bag of base fluid
                (Na ${fmt(baseNa)})
                <span class="note">
                  (formula is per 1 L, scaled to your bag)
                </span>.
              </li>

              <li>
                Restored renal perfusion should then excrete
                the excess Na⁺;
                if not improving,
                move to free-water replacement below.
              </li>
            </ul>
          `;
        }

        body += `
          <p>
            <strong>
              Free water deficit
              (normovolaemic path / after resuscitation):
            </strong>
          </p>

          <div class="formula">
            FWD =
            ((current Na ÷ desired Na) − 1)
            × 0.6 × BW
            =
            ((${fmt(v.na)} ÷ ${fmt(targetNa)}) − 1)
            × 0.6 × ${fmt(wt, 1)}
          </div>

          <ul>
            <li>
              Free water deficit
              ${dose(`${fmt(freeWaterDeficit, 2)} L`)}
              —
              replace with 5% dextrose at
              ${dose(`${fmt(d5wHr)} ml/h`)}
              over
              ${fmt(hours)}
              h
              (rule of thumb:
              4 ml/kg/h of D5W =
              ${fmt(4 * wt)}
              ml/h drops Na⁺ ~0.5 mmol/h).
            </li>

            <li>
              Run maintenance + ongoing losses
              as a separate isotonic crystalloid line.
            </li>

            ${
              v.na > 160
                ? `
                  <li>
                    Chronic Na⁺ &gt;160 forms idiogenic osmoles
                    over 24–48 h —
                    correct over 2–3 days.
                  </li>
                `
                : ''
            }

            ${
              neuro
                ? `
                  <li>
                    <strong>
                      Neurological signs:
                    </strong>

                    mannitol
                    ${dose(`0.5–1 g/kg = ${fmt(0.5 * wt, 1)}–${fmt(wt, 1)} g IV over 20 min`)}

                    OR

                    7% saline
                    ${dose(`3–5 ml/kg = ${fmt(3 * wt)}–${fmt(5 * wt)} ml over 20 min`)}.
                  </li>
                `
                : ''
            }

            <li>
              Volume status ≠ sodium:
              assess and treat separately.
              Rule-outs:
              water loss
              (DI, panting, GIT/renal loss, diuretics, DM),
              salt gain
              (IV fluids, bicarbonate, enemas, hyperaldosteronism).
            </li>
          </ul>
        `;

        cards.push(
          card(
            F.hyperNa.sev,
            `Hypernatraemia correction — Na⁺ ${fmt(v.na)}`,
            pill(
              F.hyperNa.sev,
              F.hyperNa.deg
            ) +
              (neuro
                ? pill(
                    'crit',
                    'Neuro signs'
                  )
                : ''),
            body
          )
        );
      }

      if (F.hypoNa) {
        const fluidTarget = Math.min(
          v.na + 10,
          154
        );

        const addD5W =
          fluidTarget < 154
            ? ((154 - fluidTarget) *
                1000) /
              fluidTarget
            : 0;

        const hours =
          (targetNa - v.na) / 0.5;

        let body = `
          <p>
            <strong>
              Never raise Na⁺ faster than 0.5 mmol/L/h
            </strong>
            —
            especially until &gt;130
            (central pontine myelinolysis).
            Recheck q4h.
            Rise to ${fmt(targetNa)}
            should take at least
            ${dose(`${fmt(hours)} h`)}.
          </p>

          <ul>
            <li>
              Resuscitate/rehydrate with fluid Na
              within 5–10 mmol/L of the patient
              (≈ ${fmt(fluidTarget)} mmol/L).
            </li>
        `;

        if (addD5W > 0) {
          body += `
            <li>
              Mix:
              add
              ${dose(`${fmt(addD5W * bag / 1000)} ml of 5% dextrose`)}
              to a
              ${fmt(bag)}
              ml bag of 0.9% NaCl
              →
              fluid Na ≈
              ${fmt(fluidTarget)}
              mmol/L
              <span class="note">
                (formula per 1 L:
                (154 − desired) × 1000 ÷ desired,
                scaled to your bag)
              </span>.
            </li>
          `;
        } else {
          body += `
            <li>
              0.9% NaCl
              (Na 154)
              is already within 10 mmol/L
              of this patient —
              use as is.
            </li>
          `;
        }

        body += `
            <li>
              Maintenance can continue on 0.9% saline
              if Na⁺ is not rising too fast.
            </li>

            ${
              v.k != null &&
              v.k > r.kHigh
                ? `
                  <li>
                    <strong>
                      Low Na⁺ + high K⁺ →
                      rule out hypoadrenocorticism
                    </strong>
                    (and whipworm).
                  </li>
                `
                : ''
            }

            <li>
              Hypervolaemic hyponatraemia
              (CHF, cirrhosis, nephrotic syndrome —
              oedema/ascites/effusion):
              treat underlying disease;
              frusemide with saline;
              monitor Na⁺ q2–3h.
              Water restriction only for psychogenic polydipsia/
              inappropriate ADH
              (rare).
            </li>

            <li>
              Other rule-outs:
              vomiting/diarrhoea,
              renal failure,
              over-hydration on IV fluids,
              effusions;
              artefact from lipaemia/
              hyperproteinaemia/
              hyperglycaemia.
            </li>
          </ul>
        `;

        cards.push(
          card(
            F.hypoNa.sev,
            `Hyponatraemia correction — Na⁺ ${fmt(v.na)}`,
            pill(
              F.hypoNa.sev,
              F.hypoNa.deg
            ),
            body
          )
        );
      }

      if (F.hypoGlu) {
        const body =
          `
            <ul>
              <li>
                Bolus:
                50% dextrose
                ${dose(`0.5–1 ml/kg = ${fmt(0.5 * wt, 1)}–${fmt(wt, 1)} ml`)}
                diluted 1:3 with saline
                (reduces vasculitis),
                IV over 5 min.
              </li>

              <li>
                Offer food if bright
                and no contraindication.
              </li>

              <li>
                <strong>
                  Ongoing hypoglycaemia →
                  dextrose CRI in the bag.
                </strong>
                Remove the same volume from the bag first,
                then add 50% dextrose
                (per your ${fmt(bag)} ml bag):
              </li>
            </ul>
          ` +
          tbl(`
            <tr>
              <th>Dextrose %</th>
              <th>
                Add 50% dextrose to
                ${fmt(bag)} ml bag
              </th>
              <th>Line required</th>
            </tr>

            <tr>
              <td>2.5%</td>
              <td>${fmt(dexAdd(2.5))} ml</td>
              <td>Peripheral vein OK</td>
            </tr>

            <tr>
              <td>5%</td>
              <td>${fmt(dexAdd(5))} ml</td>
              <td>
                Peripheral vein OK
                (maximum for peripheral)
              </td>
            </tr>

            <tr class="hl">
              <td>7.5%</td>
              <td>${fmt(dexAdd(7.5))} ml</td>
              <td>
                <strong>
                  Central line required
                </strong>
              </td>
            </tr>

            <tr class="hl">
              <td>10%</td>
              <td>${fmt(dexAdd(10))} ml</td>
              <td>
                <strong>
                  Central line required
                </strong>
              </td>
            </tr>
          `) +
          `
            <p class="note">
              <span aria-hidden="true">⚠️</span>
              <strong>
                Anything above 5% dextrose is hyperosmolar
                and must run through a central line
                (e.g. jugular/drum line) —
                never a peripheral catheter
              </strong>
              (phlebitis and thrombosis risk).
              Formula:
              add = bag ml × desired % ÷ 50.
            </p>

            <ul>
              <li>
                Start at 2.5%,
                recheck glucose q2h
                and step up to 5% if still hypoglycaemic.
                Refractory despite 5%
                (severe insulin overdose, insulinoma)
                →
                place a central line for 7.5–10%
                ± occasional dextrose boluses.
              </li>

              <li>
                Insulin overdose:
                continue ≥2.5% glucose
                until insulin wears off;
                monitor K⁺
                (shifts intracellularly —
                may need aggressive supplementation)
                and phosphate.
              </li>

              <li>
                Suspected insulinoma:
                avoid over-shooting glucose
                (stimulates insulin release);
                persistent severe cases →
                glucagon
                ${dose(`50 ng/kg bolus = ${fmt(50 * wt)} ng`)}
                then CRI
                5–40 ng/kg/min.
              </li>
            </ul>
          `;

        cards.push(
          card(
            'crit',
            `Hypoglycaemia — glucose ${fmt(v.glu, 1)}`,
            pill(
              'crit',
              'Treat now'
            ),
            body
          )
        );
      }

      if (F.hyperGlu) {
        cards.push(
          card(
            'warn',
            `Hyperglycaemia — glucose ${fmt(v.glu, 1)}`,
            null,
            `
              <ul>
                <li>
                  Glucose-free fluids;
                  monitor glucose q2–4h.
                </li>

                <li>
                  Stress hyperglycaemia
                  (esp. cats)
                  vs diabetes:
                  history of PU/PD,
                  weight loss,
                  polyphagia;
                  glucose curve
                  (stress resolves);
                  fructosamine for prior glycaemic status.
                  Can exceed renal threshold →
                  glucosuria.
                </li>
              </ul>
            `
          )
        );
      }

      if (F.hypoCa) {
        const body = `
          <ul>
            ${
              neuro
                ? `
                  <li>
                    <strong>
                      Seizures/tetany:
                    </strong>
                    IV calcium with diazepam IV.
                  </li>
                `
                : ''
            }

            <li>
              Calcium gluconate 10%
              ${dose(`0.5–1 ml/kg = ${fmt(0.5 * wt, 1)}–${fmt(wt, 1)} ml slow IV over 15 min`)}
              monitoring heart rate/ECG
              (stop if bradycardia).
            </li>

            <li>
              Continue as CRI
              ${dose(`0.25 ml/kg/h = ${fmt(0.25 * wt, 1)} ml/h of 10% Ca gluconate`)}
              if needed.
              Never subcutaneous
              (calcinosis cutis).
            </li>

            <li>
              Eclampsia:
              after stabilising,
              wean puppies,
              start oral calcium,
              warn about mastitis.
            </li>

            ${
              !F.hypoCa.ion &&
              v.alb != null &&
              v.alb < 26
                ? `
                  <li>
                    <strong>
                      Albumin is low
                      (${fmt(v.alb)} g/L)
                    </strong>
                    —
                    low total Ca may be artefactual;
                    measure ionised calcium before treating
                    (no clinical signs if iCa normal).
                  </li>
                `
                : ''
            }

            <li>
              Rule-outs:
              hypoalbuminaemia,
              milk fever,
              hyperphosphataemia,
              hypoparathyroidism,
              CKD,
              pancreatitis,
              phosphate enema,
              ethylene glycol,
              oxalate toxicity,
              vitamin D deficiency.
            </li>
          </ul>
        `;

        cards.push(
          card(
            F.hypoCa.sev,
            `Hypocalcaemia — ${F.hypoCa.ion ? 'iCa' : 'total Ca'} ${fmt(ca.val, 2)}`,
            pill(
              F.hypoCa.sev,
              neuro
                ? 'tetany/seizures'
                : 'treat'
            ),
            body
          )
        );
      }

      if (F.hyperCa) {
        const body = `
          <ul>
            <li>
              0.9% NaCl
              (calcium-free) —
              correct volume/dehydration
              to enhance urinary Ca excretion.
            </li>

            <li>
              ± Frusemide
              ${dose(`1–2 mg/kg = ${fmt(wt)}–${fmt(2 * wt)} mg IV/SC/PO BID`)}
              —
              only once fully hydrated;
              match urine output with input.
            </li>

            <li>
              ± Corticosteroids only
              after definitive diagnosis
              (lymphoma will be masked).
            </li>

            <li>
              Life-threatening:
              sodium bicarbonate
              ${dose(`1 mEq/kg = ${fmt(wt)} ml of 8.4% slowly over 20 min`)}
              (best with concurrent acidosis)
              or phosphate chelation
              0.25–0.5 mmol/kg IV over 4 h.
            </li>

            <li>
              Rule-outs:
              neoplasia
              (lymphoma,
              anal gland adenocarcinoma),
              primary hyperparathyroidism,
              renal secondary,
              hypoadrenocorticism,
              vitamin D toxicity
              (rodenticide),
              idiopathic
              (cats),
              haemoconcentration.
            </li>
          </ul>
        `;

        cards.push(
          card(
            'warn',
            `Hypercalcaemia — ${F.hyperCa.ion ? 'iCa' : 'total Ca'} ${fmt(ca.val, 2)}`,
            null,
            body
          )
        );
      }

      if (F.hypoPhos) {
        const low =
          0.01 * wt;

        const high =
          0.05 * wt;

        const body = `
          <ul>
            <li>
              ${
                F.hypoPhos.initiate
                  ? '<strong>Initiate supplementation (phos &lt;0.30):</strong>'
                  : 'Consider supplementation (phos &lt;0.65):'
              }

              Na/K phosphate
              ${dose(`0.01–0.05 mmol/kg/h = ${fmt(low, 2)}–${fmt(high, 2)} mmol/h`)}
              in
              <strong>
                calcium-free fluids
              </strong>
              (0.9% NaCl).
            </li>

            <li>
              Avoid if hypercalcaemic
              or anuric/oliguric
              ${
                F.hyperCa || aki
                  ? ' — <strong>applies to this patient</strong>'
                  : ''
              }.
            </li>

            <li>
              If also supplementing K⁺:
              give half as KCl,
              half as KPO₄.
            </li>

            <li>
              Discontinue at serum phosphorus
              0.9 mmol/L;
              monitor q6h.
            </li>
          </ul>
        `;

        cards.push(
          card(
            F.hypoPhos.sev === 'warn'
              ? 'warn'
              : 'info',
            `Hypophosphataemia — phos ${fmt(v.phos, 2)}`,
            null,
            body
          )
        );
      }

      if (F.hyperPhos) {
        cards.push(
          card(
            'warn',
            `Hyperphosphataemia — phos ${fmt(v.phos, 2)}`,
            null,
            `
              <ul>
                <li>
                  0.9% NaCl fluid therapy;
                  treat underlying disease.
                </li>

                <li>
                  Can use insulin + dextrose protocol
                  (as for hyperkalaemia)
                  to drive cellular uptake.
                </li>

                <li>
                  Correct hypocalcaemia
                  if present.
                </li>
              </ul>
            `
          )
        );
      }

      if (
        F.acidosis &&
        !F.hyperK
      ) {
        cards.push(
          card(
            F.acidosis.sev,
            `Metabolic acidosis — HCO₃⁻ ${fmt(v.hco3, 1)}`,
            null,
            `
              <ul>
                <li>
                  Alkalinising fluid
                  (Hartmann's/Plasmalyte 148)
                  and correct perfusion —
                  most acidoses resolve with volume.
                </li>

                ${
                  F.acidosis.severe
                    ? `
                      <li>
                        HCO₃⁻ &lt;10:
                        bicarbonate
                        ${dose(`1 mmol/kg = ${fmt(wt)} ml of 8.4% over 30 min`)}
                        —
                        adverse effects relate to speed;
                        acts in ~15 min.
                      </li>
                    `
                    : ''
                }

                <li>
                  Acidosis shifts K⁺ out of cells —
                  recheck K⁺ as pH corrects.
                </li>
              </ul>
            `
          )
        );
      }

      if (F.lowTP) {
        cards.push(
          card(
            'warn',
            `Low oncotic pressure — TP ${fmt(v.tp)} g/L`,
            null,
            `
              <ul>
                <li>
                  TP &lt;45 g/L →
                  consider colloids for blood volume restoration only
                  ${
                    sepsis ||
                    aki ||
                    coag
                      ? ` — <strong>but avoid here:</strong> ${[
                          sepsis
                            ? 'sepsis'
                            : null,
                          aki
                            ? 'AKI'
                            : null,
                          coag
                            ? 'coagulopathy'
                            : null
                        ]
                          .filter(Boolean)
                          .join(', ')}
                        (consider plasma/albumin instead)`
                      : ''
                  }.
                </li>

                <li>
                  Colloid rules:
                  no large cumulative doses or CRIs;
                  monitor aPTT;
                  anaphylactoid reactions possible.
                </li>

                ${
                  v.pcv != null &&
                  v.pcv < 25
                    ? `
                      <li>
                        PCV ${fmt(v.pcv)}% —
                        consider whole blood;
                        monitor PCV during dilution.
                      </li>
                    `
                    : ''
                }
              </ul>
            `
          )
        );
      }

      {
        const monitoring = [];

        if (
          F.hyperNa ||
          F.hypoNa
        ) {
          monitoring.push(
            'Electrolytes q4h while correcting sodium; adjust rate to keep ΔNa ≤0.5 mmol/L/h.'
          );
        }

        if (
          F.hypoK ||
          F.hyperK
        ) {
          monitoring.push(
            'Recheck K⁺ frequently; ECG for K⁺ >6.0 or severe hypokalaemia.'
          );
        }

        if (
          F.hypoGlu ||
          F.hyperGlu ||
          paed
        ) {
          monitoring.push(
            'Blood glucose q2–4h.'
          );
        }

        if (F.hypoPhos) {
          monitoring.push(
            'Phosphate q6h; stop supplementation at 0.9 mmol/L.'
          );
        }

        if (F.hypoCa) {
          monitoring.push(
            'Heart rate/ECG during calcium infusion.'
          );
        }

        if (shock) {
          monitoring.push(
            'Resuscitation end-points: mentation, HR (dog 90–140, cat ~180), MM pink, CRT 1–2 s, T >37.5°C, MAP 70–80, SBP >100, UOP >1 (>2 on fluids) ml/kg/h, SpO₂ >95%, lactate <2, base deficit > −4.'
          );
        }

        monitoring.push(
          'All patients: bodyweight q12h, respiratory rate and auscultation for overload, PCV/TP for haemodilution.'
        );

        cards.push(
          card(
            'ok',
            'Monitoring & rechecks',
            null,
            `
              <ul>
                ${monitoring
                  .map(
                    (item) =>
                      `<li>${item}</li>`
                  )
                  .join('')}
              </ul>
            `
          )
        );
      }

      out.innerHTML =
        cards.join('');
    }

    root
      .querySelectorAll(
        '#inputs input, #inputs select'
      )
      .forEach((element) => {
        element.addEventListener(
          'input',
          render
        );
      });

    render();
  }
}

if (
  !customElements.get(
    's-fluid-therapy-calculator'
  )
) {
  customElements.define(
    's-fluid-therapy-calculator',
    FluidTherapyCalculator
  );
}
